import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Logo from '../components/Logo';
import DragAndDrop from '../components/DragAndDrop';
import ConversionProgress from '../components/ConversionProgress';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import { convertImage } from '../utils/imageUtils';
import BuyMeCoffee from '../components/BuyMeCoffee';
import Footer from '../components/Footer';
import PhraseCarousel from '../components/PhraseCarousel';

function Converter() {
  const { from, to } = useParams();
  const [convertedFiles, setConvertedFiles] = useState([]);
  const [isConverting, setIsConverting] = useState(false);
  const [currentFile, setCurrentFile] = useState(0);
  const [totalFiles, setTotalFiles] = useState(0);
  const [error, setError] = useState(null);

  const phrases = [
    "Online image converter",
    "Convert PNG to JPG online",
    "Convert image online",
    "High-quality image conversion",
    "Online photo converter",
    "Free photo converter",
    "Image converter online",
    "Best online image converter",
    "Image conversion tool"
  ];

  const handleFilesDrop = async (files) => {
    setIsConverting(true);
    setError(null);
    setCurrentFile(0);
    setTotalFiles(files.length);
    const converted = [];

    try {
      for (let i = 0; i < files.length; i++) {
        setCurrentFile(i + 1);
        const result = await convertImage(files[i], from, to);
        converted.push(result);
      }
      setConvertedFiles(converted);
    } catch (error) {
      console.error('Error converting files:', error);
      setError('Error converting files. Please make sure you are using the correct file format.');
    } finally {
      setIsConverting(false);
    }
  };

  // Определяем, поддерживается ли обратная конвертация
  // const supportsReverseConversion = !['heic', 'tiff'].includes(to.toLowerCase());

  return (
    <div className="container mx-auto px-4">
      <Logo />
      <Link to="/en/image-converter" className="block text-center text-blue-600 hover:text-blue-800 mb-8">
        Go to other converters
      </Link>
      
      <div className="flex items-center justify-center space-x-4 mb-8">
        <span className="text-xl font-semibold">{from.toUpperCase()}</span>
        <div className="flex space-x-2">
          <ArrowLongRightIcon className="w-6 h-6 text-blue-500" />
          {/* {supportsReverseConversion && (
            <ArrowLongLeftIcon className="w-6 h-6 text-blue-500" />
          )} */}
        </div>
        <span className="text-xl font-semibold">{to.toUpperCase()}</span>
      </div>

      <div className="max-w-xl mx-auto">
        <input
          type="file"
          accept={`.${from.toLowerCase()}`}
          onChange={(e) => handleFilesDrop(Array.from(e.target.files))}
          className="w-full mb-4 p-2 border rounded"
          multiple
        />
        
        <DragAndDrop onFilesDrop={handleFilesDrop} fromFormat={from} />

        {isConverting && (
          <ConversionProgress
            currentFile={currentFile}
            totalFiles={totalFiles}
          />
        )}

        {error && (
          <div className="text-red-500 text-center mt-4">
            {error}
          </div>
        )}

        {convertedFiles.length > 0 && (
          <div className="mt-8">
            <h2 className="text-xl font-semibold mb-4">Converted Files:</h2>
            <div className="space-y-4">
              {convertedFiles.map((file, index) => (
                <div key={index} className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
                  <span>{file.name}</span>
                  <a
                    href={file.url}
                    download={file.name}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                  >
                    Download
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <BuyMeCoffee />

      <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-6">
        Free online {from.toUpperCase()} to {to.toUpperCase()} converter
      </h1>

      <h2 className="text-2xl font-semibold mb-4">
        Fast, secure & private image conversion
      </h2>
      
      <p className="mb-6">
        Convert {from.toUpperCase()} files to {to.toUpperCase()} format instantly with our free online image converter. 
        No file send to server needed — all conversions happen right in your browser for maximum privacy.
      </p>

      <h3 className="text-xl font-semibold mb-3">
        Key features of Llama convert
      </h3>

      <div className="space-y-2">
        <p>✓ Lightning-fast conversion (under 1 second)</p>
        <p>✓ 100% private — files never leave your device</p>
        <p>✓ No file size limits</p>
        <p>✓ Zero ads or popups</p>
        <p>✓ Works offline after initial load</p>
      </div>

    </div>

    <div className="flex items-center justify-center bg-gray-100 mb-8">
      <PhraseCarousel phrases={phrases} direction="ltr" />
    </div>

    <Footer />

    </div>
  );
}

export default Converter;
